import { makePersisted } from '@solid-primitives/storage'
import { createRoot } from 'solid-js'
import { createStore } from 'solid-js/store'

export interface AuthStateType {
  token: string | null
  user: Record<string, unknown> | null
  companyId: string | null
  companies: Array<{
    company: { id: string; name: string; slug: string; domain?: string; logo?: string }
    role: string
    isDefault: boolean
  }>
}

const [authStore, setAuthStore] = createRoot(() =>
  makePersisted(
    createStore<AuthStateType>({
      token: null,
      user: null,
      companyId: null,
      companies: []
    }),
    { name: 'fj-auth', storage: localStorage }
  )
)

/**
 * Vacía la sesión guardada. Se llama al cerrar sesión y cuando el servidor
 * responde 401: dejar el token muerto en localStorage hacía que el guard
 * (que sólo comprueba que exista) siguiera dando por buena la sesión.
 */
export const clearAuth = () => {
  setAuthStore({ token: null, user: null, companyId: null, companies: [] })
}

export { authStore, setAuthStore }
